import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 15.997c1.103-.094 2.547-.852 3.822-2.125l-1.697-1.697C.85 13.449.092 14.893 0 15.997m1.805-8.174.381.223.469-.813q.16-.278.383-.5l3.721-3.72H5.105c-.854 0-1.657.332-2.263.937L1.47 5.32a1.59 1.59 0 0 0-.469 1.133c0 .427.167.829.47 1.13.117.118.238.186.334.24m6.951 5.518-.807.465.258.442c.039.07.105.187.224.305.303.3.704.467 1.13.467.428 0 .829-.166 1.131-.47l1.372-1.37A3.18 3.18 0 0 0 13 10.92l.001-1.703-3.741 3.74a2.4 2.4 0 0 1-.504.385M15.483.51c-.56-.561-1.474-.67-2.166-.271L9.815 2.255l-.762.757h-.034L4.167 7.864a.8.8 0 0 0-.127.168l-.473.82.015.009-.93 1.58 2.898 2.897 2.41-1.386.003-.003a.8.8 0 0 0 .163-.124l4.872-4.871v-.005l.61-.606 2.144-3.667A1.795 1.795 0 0 0 15.483.51"
    }, null, -1)
  ])))
}
export default { render: render }